import { Component, Event, EventEmitter, Host, Prop, h } from '@stencil/core';
import { ConfigService } from '../../../services/config-service';
import { pathStore } from '../../../store/path-store';
import { If } from '../../utils/If';


@Component({
  tag: 'quick-access-bar',
  styleUrl: 'quick-access-bar.scss',
  shadow: true,
})
export class QuickAccessBar {
  @Prop() isMain: boolean = false;
  @Prop() isLoggedin: boolean = false;
  @Prop() redirectDomainUrl: string = '';
  @Prop() showSearchIcon: boolean = false;
  @Prop() wishList: { enabled: boolean; count: number } = { enabled: false, count: 0 };
  @Prop() cartFlow: { enabled: boolean; count: number } = { enabled: false, count: 0 };
  @Prop() customLogout: boolean = false;
  @Prop() customerInfo: any = {};
  @Prop() firstName: string = '';
  @Prop() showClose: boolean = true;
  @Event() proceedToCart: EventEmitter<void>;
  @Event() proceedToWishlist: EventEmitter<void>;
  @Event() proceedToSearch: EventEmitter<void>;
  @Event() logout: EventEmitter<void>;
  @Event() showLogin: EventEmitter<void>;
  @Event() closeModule: EventEmitter<void>;


  onLogOut = (event: any) => {
    event.stopPropagation();
    this.logout.emit();
  };

  onShowLogin = (event: any) => {
    if (this.isMain && ConfigService.sessionSharingDomain) {
      window.location.href = ConfigService.sessionCheckLoginPath;
      return;
    }
    event.stopPropagation();
    this.showLogin.emit();
  };

  render() {
    const assetPath = pathStore.assetPath;
    return (
      <Host>
        <div class="flex gap-4 justify-end items-center">
          <If
            condition={this.isLoggedin}
            children={
              <div class="hidden md:flex items-center gap-4 ">
                <a href={`${this.redirectDomainUrl}manage_orders`} class="font-semibold text-sm ">
                  Manage Orders / Bookings
                </a>
                <component-separator />
              </div>
            }
          />
          <If
            condition={this.showSearchIcon}
            children={
              <div class="flex gap-4 items-center cursor-pointer" onClick={() => this.proceedToSearch.emit()}>
                {/* <img width={26} height={26} alt="" src={assetPath + 'icons/wishlist.svg'} /> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-search-icon lucide-search"
                >
                  <path d="m21 21-4.34-4.34" />
                  <circle cx="11" cy="11" r="8" />
                </svg>
                <component-separator />
              </div>
            }
          />

          <If
            condition={this.wishList.enabled}
            children={
              <div class="flex items-center gap-4">
                <div onClick={() => this.proceedToWishlist.emit()} class="relative cursor-pointer">
                  <img width={26} height={26} alt="" src={assetPath + 'icons/wishlist.svg'} />
                  <If
                    condition={this.wishList.count > 0}
                    children={
                      <span class="absolute font-bold w-4 h-4 flex items-center justify-center leading-none bg-white text-black rounded-full text-[10px] -right-2 -top-1">
                        {this.wishList.count}
                      </span>
                    }
                  />
                </div>
                <component-separator />
              </div>
            }
          />
          <If
            condition={this.cartFlow.enabled}
            children={
              <div class="flex items-center gap-4">
                <div onClick={() => this.proceedToCart.emit()} class="relative cursor-pointer">
                  <img width={26} height={26} src={assetPath + 'icons/cart.svg'} />
                  <If
                    condition={this.cartFlow.count > 0}
                    children={
                      <span class="absolute font-bold w-4 h-4 flex items-center justify-center leading-none bg-white text-black rounded-full text-[10px] -right-2 -top-1">
                        {this.cartFlow.count}
                      </span>
                    }
                  />
                </div>
                <component-separator />
              </div>
            }
          />
          <a href={`${this.redirectDomainUrl}customer_support`}>
            <img width={20} height={20} alt="customer support" src={`${assetPath}icons/customerSupport.svg`} />
          </a>
          <If condition={this.showClose} children={<component-separator class="block md:hidden" />} />
          <If
            condition={this.showClose}
            children={
              <div class={"block md:hidden"} onClick={() => this.closeModule.emit()}>
                <img width={30} height={30} src={`${assetPath}icons/closeWhite.svg`} alt="close" />
              </div>
            }
          />
          <component-separator class="hidden md:block" />
          <if-component class="hidden md:block" condition={this.isLoggedin}>
            <profile-dropdown
              customLogout={this.customLogout}
              redirectDomainUrl={this.redirectDomainUrl}
              onLogout={this.onLogOut}
              firstname={this.customerInfo?.firstname || this.firstName}
              slot="then"
              assetPath={assetPath}
            />
            <custom-button slot="else" onButtonClick={this.onShowLogin}>
              Sign-In
            </custom-button>
          </if-component>
        </div>
      </Host>
    );
  }
}
